export default __webpack_public_path__ + "static/media/Gelso.b01bfc9e.png";